var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertMindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.838,
    height: 95.118,
    viewBox: "0 0 80.838 95.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(-9.6 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M44.9,21.5A16.4,16.4,0,1,0,61.3,37.9,16.41,16.41,0,0,0,44.9,21.5Zm8,13.4-8.3,9.5A2.271,2.271,0,0,1,43,45h-.1a2.035,2.035,0,0,1-1.5-.6l-5.1-5.1a2.121,2.121,0,0,1,3-3l3.5,3.6,6.9-7.8a2.126,2.126,0,0,1,3.2,2.8Z",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M89.8,51.1l-9-13.7a6.083,6.083,0,0,1-.8-2.7A35.267,35.267,0,0,0,9.6,37.8,40.8,40.8,0,0,0,23.8,68.1a4.724,4.724,0,0,1,1.7,3.5V91.8a3.135,3.135,0,0,0,2.8,3.1l30.3,2.7a3.044,3.044,0,0,0,3.3-3.1V80.1a1.752,1.752,0,0,1,1.7-1.7H74.2a5.848,5.848,0,0,0,5.9-5.9V58.3a1.216,1.216,0,0,1,1.2-1.2h5.2A3.871,3.871,0,0,0,89.8,51.1ZM44.9,58.5A20.6,20.6,0,1,1,65.5,37.9,20.571,20.571,0,0,1,44.9,58.5Z",
    fill: "#621bc0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertMindIcon);
export default __webpack_public_path__ + "static/media/expert-mind-icon.38087a6605e2666c9498e475df610cdd.svg";
export { ForwardRef as ReactComponent };